import { useState } from "react";
import { UserRolesModel, createUserRolesInfo } from "../../accounts/models/UserRolesInfo";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { Authentication } from "../../common/views/Authentication";
import { DataUtils } from "../../common/views/DataUtils";
import { BannerInfo } from "../models/BannerInfo";
import { ContactInfo } from "../models/ContactInfo";
import HomeService from "../services/HomeService";

export function useHomeVM() {
    const homeService = new HomeService();

    const [userRoles, setUserRoles] = useState<UserRolesModel>(createUserRolesInfo());
    const [contacts, setContacts] = useState<ContactInfo[]>([]);
    const [banners, setBanners] = useState<BannerInfo[]>([]);
    const [showAllBrand, setShowAllBrands] = useState(false);

    const onLoad = () => {
        console.log("Home VM onloaded");
        setUserRoles(Authentication.getUserRoles());
        getContacts();
        getBanners();
    };

    const getContacts = () => {
        const onResult = (result: IDataResult) => {
            if (result.status === ResponseStatus.success) {
                setContacts(result.data);
            }
        }

        DataUtils.onRequest(homeService.getContacts(), onResult);
    }

    const getBanners = () => {
        const onResult = (result: IDataResult) => {
            if (result.status === ResponseStatus.success) {
                setBanners(result.data);
            }
        }

        const request = homeService.getBanners();
        DataUtils.onRequest(request, onResult);
    }

    return {
        onLoad,
        userRoles,
        setUserRoles,
        banners,
        contacts,
        showAllBrand, setShowAllBrands
    }
}